import React, { useState, useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { playSound, stopSound } from './sound';

export default function Timer({ seconds, onTimeUp, isMuted = false }) {
  const [timeLeft, setTimeLeft] = useState(seconds);
  const [isActive, setIsActive] = useState(true);
  const isFirstRender = useRef(true);
  const timerRef = useRef(null);
  const bgAudioRef = useRef(null);

  useEffect(() => {
    if (isMuted) return undefined;

    playSound('/show.wav');
    const bgAudio = playSound('/timer.mp3', { loop: true });
    bgAudioRef.current = bgAudio;

    return () => {
      stopSound(bgAudio);
    };
  }, [isMuted]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    if (timeLeft <= 0 && isActive) {
      // إيقاف الصوت عند انتهاء الوقت والوقت يصل للصفر
      if (bgAudioRef.current) {
        bgAudioRef.current.pause();
      }
      setIsActive(false);
      onTimeUp();
      return;
    }
  }, [timeLeft, onTimeUp, isActive]);

  useEffect(() => {
    if (timeLeft <= 0 || !isActive) return;
    timerRef.current = setInterval(() => setTimeLeft(prev => prev - 1), 1000);
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [timeLeft, isActive]);

  // دالة لإيقاف المؤقت
  const stopTimer = () => {
    setIsActive(false);
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
    if (bgAudioRef.current) {
      bgAudioRef.current.pause();
    }
  };

  // تصدير الدالة للاستخدام من الخارج
  useEffect(() => {
    // إضافة دالة stopTimer إلى window للوصول إليها من QuestionModal
    window.stopTimer = stopTimer;
    return () => {
      window.stopTimer = null;
    };
  }, []);

  const isWarning = timeLeft <= 5;

  return (
    <motion.div 
      animate={isWarning ? { scale: [1, 1.1, 1] } : {}}
      transition={isWarning ? { repeat: Infinity, duration: 0.5 } : {}}
      className={`relative w-12 h-12 sm:w-14 sm:h-14 md:w-20 md:h-20 flex items-center justify-center rounded-full border-4 shadow-lg ${isWarning ? 'bg-red-700 border-red-200 shadow-[0_0_18px_rgba(185,28,28,0.85)]' : 'bg-emerald-950 border-amber-300 shadow-[0_0_18px_rgba(14,90,66,0.45)]'}`}
    >
      <span className="text-lg sm:text-xl md:text-3xl font-black text-white drop-shadow-[0_2px_4px_rgba(0,0,0,0.7)]">{timeLeft}</span>
    </motion.div>
  );
}
